import { isPlatformServer } from '@angular/common'
import { inject, Injectable, PLATFORM_ID } from '@angular/core'

import { LogLevel } from '../log-level.enum'
import { LogTransport } from '../log-transport'
import { CONSOLE_LOG_TRANSPORT_CONFIG } from './console-log-transport-config.injection-token'
import { timeFormat } from './console-log-utils'

@Injectable()
export class BrowserConsoleLogTransport extends LogTransport {
  protected readonly logLevel = inject(CONSOLE_LOG_TRANSPORT_CONFIG).logLevel

  constructor() {
    super()
    if (isPlatformServer(inject(PLATFORM_ID))) {
      throw new Error('This log transport is only for client side use - consider using "NodeConsoleLogTransport"')
    }
  }

  log(level: LogLevel, clazzName: string, color: string, timestamp: Date, args: any[]) {
    if (this.isLevelEnabled(level)) {
      const now = timeFormat.format(timestamp)
      const firstArgument = args.splice(0, 1)[0]

      if (typeof firstArgument === 'string') {
        // we have a string with potential message format
        args.splice(0, 0, `%c${now} - ${clazzName} :: ${firstArgument}`, `color:${color}`)
      } else {
        args.splice(0, 0, `%c${now} - ${clazzName} ::`, `color:${color}`, firstArgument)
      }

      /* eslint-disable no-console */
      switch (level) {
        case LogLevel.DEBUG:
          console.debug(...args)
          break
        case LogLevel.ERROR:
          console.error(...args)
          break
        case LogLevel.INFO:
          console.info(...args)
          break
        case LogLevel.WARN:
          console.warn(...args)
          break
        case LogLevel.OFF:
        default:
          break
      }
      /* eslint-enable no-console */
    }
  }
}
